<template>
  <div class="w-100">
    <form ref="form" v-kendo-validator novalidate>
      <!-- <div class="page-header d-flex w-100"> -->
      <!-- <div class="title-col d-flex w-50">
          <span class="title-icon">
            <span class="nt-plus-square-fill"></span>
          </span>
          <span class="title-text">Add Ons</span>
        </div>
        <div class="text-right ml-auto">
          <button class="k-button k-primary ml-2" type="button" @click="save" v-if="!readOnly">Save</button>
      </div>-->
      <!-- </div> -->
      <div class="page-body">
        <div class="bg-white p-3">
          <span class="add-ons">Add-Ons</span>
          <div class="form-group">
            <label v-if="!readOnly">Search Add-Ons</label>
            <kendo-multiselect
              :data-source="getAddOns"
              :data-text-field="'name'"
              :data-value-field="'featureID'"
              class="w-100"
              :value="tenantAddOns"
              :disabled="readOnly"
              @change="add"
            ></kendo-multiselect>
          </div>
          <!-- <div class="text-right ml-auto">
            <button class="k-button k-green ml-2">Add</button>
          </div>-->
        </div>
        <!-- <div class="bg-white p-4">
          <span>Selected Add-Ons</span>
          <span v-for="a in tenantAddOns" :key="a.code">{{a.name}}</span>
        </div>-->
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, createNamespacedHelpers } from "vuex";
import { notifyApiError, notify } from "../../utils/notification-helper";
const { mapActions, mapState } = createNamespacedHelpers("onboarding");
export default {
  props: ["readOnly"],
  methods: {
    ...mapActions(["saveAddons", "addAddons"]),
    save: function() {
      this.saveAddons()
        .then(message => {
          notify(message);
          this.canContinue();
        })
        .catch(notifyApiError);
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
    },
    add(event) {
      this.addAddons(event.sender.value());
    }
  },
  computed: {
    ...mapState(["tenantAddOns"]),
    ...mapGetters(["getAddOns"])
  }
};
</script>

<style>
.add-ons {
  font-size: 15px;
}
.k-multiselect .k-multiselect-wrap, .k-dropdowntree .k-multiselect-wrap {
    border-radius: 5px;
    border-color: #0047b2;
}
</style>